module.exports = __webpack_public_path__ + "img/home_img_04.075b9284.png";